import * as OTPAuth from "otpauth";
import QRCode from "qrcode";

const STORAGE_KEY = "fb11_totp";

function getConfig() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}"); }
  catch { return {}; }
}

function saveConfig(c) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(c));
}

export function generateTOTP(userId) {
  const totp = new OTPAuth.TOTP({
    issuer: "FinBoard",
    label: userId,
    algorithm: "SHA1",
    digits: 6,
    period: 30,
    secret: new OTPAuth.Secret({ size: 20 })
  });
  return totp;
}

export function saveTOTPSecret(userId, secret) {
  const config = getConfig();
  config[userId] = { secret: secret, enabled: true, setupAt: new Date().toISOString() };
  saveConfig(config);
}

export function isTOTPEnabled(userId) {
  const config = getConfig();
  return !!(config[userId] && config[userId].enabled);
}

export function verifyTOTP(userId, token) {
  const config = getConfig();
  if (!config[userId] || !config[userId].secret) return false;
  const totp = new OTPAuth.TOTP({
    issuer: "FinBoard",
    label: userId,
    algorithm: "SHA1",
    digits: 6,
    period: 30,
    secret: OTPAuth.Secret.fromBase32(config[userId].secret)
  });
  const delta = totp.validate({ token: token, window: 1 });
  return delta !== null;
}

export function disableTOTP(userId) {
  const config = getConfig();
  delete config[userId];
  saveConfig(config);
}

export async function generateQRCode(totp) {
  const uri = totp.toString();
  try {
    return await QRCode.toDataURL(uri, { width: 250, margin: 2, color: { dark: "#E2E8F0", light: "#0F172A" } });
  } catch (e) { console.error("QR Error:", e); return null; }
}
